import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(authService.getToken()).pipe(
    switchMap((accessToken) => {
      if (accessToken) {
        const cloned = req.clone({
          headers: req.headers.set('Authorization', accessToken),
        });
        return next(cloned);
      }
      return next(req);
    })
  );
};
